module.exports = __webpack_public_path__ + "img/defaultVoucherIco.a8574a3a.png";